import TokenResponse from 'owa-service/lib/contract/TokenResponse';
import tokenRequest from 'owa-service/lib/factory/tokenRequest';
import RequestOptions from 'owa-service/lib/RequestOptions';
import sleep from 'owa-sleep';
import getAccessTokenforResourceOperation from 'owa-service/lib/operation/getAccessTokenforResourceOperation';
import { logUsage } from 'owa-analytics-actions';
import { getUserToken } from './utils/userTokenHandler';

const RETRY_DELAY = 1500;
export const SCENARIO_NAME = 'OWA_GetAccessTokenForResource';

export default async function getAccessTokenforResourceFromServer(
    resource: string
): Promise<TokenResponse> {
    const userToken = await getUserToken();
    const options: RequestOptions = { isUserActivity: false };
    return getAccessTokenforResourceOperation(
        tokenRequest({ Resource: resource, UserToken: userToken }),
        options
    );
}

/**
 * Adds a retry with timeout when fetching Access Token from server
 * @param resource - the resource string
 * @param retryCount - the retry count
 * @param error - the Error to log performance data
 * @returns - TokenResponse wrapped around in a Promise
 */
export async function getAccessTokenforResourceFromServerWithRetry(
    resource: string,
    retryCount: number,
    error?: Error,
    retryDelay: number = RETRY_DELAY
): Promise<TokenResponse> {
    if (retryCount < 1) {
        logUsage(SCENARIO_NAME, [resource, retryCount, error ? error.toString() : '']);
        return Promise.reject();
    }

    return getAccessTokenforResourceFromServer(resource).catch(error =>
        sleep(retryDelay).then(() => {
            return getAccessTokenforResourceFromServerWithRetry(
                resource,
                retryCount - 1,
                error,
                retryDelay * 2
            );
        })
    );
}
